import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  StyledPreviousPayrolls,
  StyledTitle,
  StyledCols,
  StyledCol,
  StyledButtonsWrapper,
  StyledButtonSecondary,
  StyledDropdownInput,
  StyledLabel
} from './style';

const PreviousPayrolls = ({
  roles,
  months,
  years,
  listManagedUsers,
  onChangeYears,
  employeeSelected,
  setEmployeeSelected,
  onClickBtn,
  openModalRRHH
}) => {
  const [yearSelected, setYearSelected] = useState([]);
  const [monthSelected, setMonthSelected] = useState([]);

  useEffect(() => {
    setYearSelected(!years?.length ? [] : years[0]);
    setMonthSelected(!months?.length ? [] : months[0]);
  }, []);

  return (
    <StyledPreviousPayrolls>
      <StyledTitle>DESCARGAR NÓMINAS ANTERIORES</StyledTitle>
      {roles.includes('ROLE_ACCESS_RRHH') ? (
        <StyledTitle>{employeeSelected.text}</StyledTitle>
      ) : (
        roles.includes('ROLE_ACCESS_MANAGER') && (
          <StyledCols>
            <StyledCol>
              <StyledLabel label="Empleado" className="mb-5" />
              <StyledDropdownInput
                list={listManagedUsers}
                label={employeeSelected.text}
                onSelect={user => setEmployeeSelected(user)}
              />
            </StyledCol>
          </StyledCols>
        )
      )}
      {Object.keys(monthSelected).length > 0 &&
      Object.keys(yearSelected).length > 0 ? (
        <>
          <StyledCols>
            <StyledCol>
              <StyledLabel label="Mes" />
              <StyledDropdownInput
                list={months}
                label={monthSelected.text}
                onSelect={month => {
                  setMonthSelected(month);
                }}
              />
            </StyledCol>
            <StyledCol>
              <StyledLabel label="Año" />
              <StyledDropdownInput
                list={years}
                label={yearSelected.text}
                onSelect={year => {
                  setYearSelected(year);
                  onChangeYears(year);
                }}
              />
            </StyledCol>
          </StyledCols>
          <StyledCols>
            <StyledCol>
              <StyledButtonsWrapper>
                {/* <StyledButtonGhost ghost>VER</StyledButtonGhost> */}
                <StyledButtonSecondary
                  secondary
                  onClick={() => {
                    onClickBtn(yearSelected, monthSelected, employeeSelected);
                  }}
                >
                  DESCARGAR
                </StyledButtonSecondary>
              </StyledButtonsWrapper>
            </StyledCol>
          </StyledCols>
          {roles.includes('ROLE_ACCESS_RRHH') && (
            <>
              <StyledTitle>Gestionar nóminas de otros usuarios</StyledTitle>
              <StyledButtonsWrapper>
                <StyledButtonSecondary secondary onClick={openModalRRHH}>
                  SELECCIONAR USUARIO
                </StyledButtonSecondary>
              </StyledButtonsWrapper>
            </>
          )}
        </>
      ) : (
        <StyledTitle>No existen nominas para este empleado</StyledTitle>
      )}
    </StyledPreviousPayrolls>
  );
};

PreviousPayrolls.propTypes = {
  months: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string,
      id: PropTypes.number
    })
  ),
  years: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string,
      id: PropTypes.string
    })
  ),
  onChangeYears: PropTypes.func,
  onClickBtn: PropTypes.func
};

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(PreviousPayrolls);
